import { render, staticRenderFns } from "./NewsLetterCreate.vue?vue&type=template&id=55c90c0f&"
import script from "./NewsLetterCreate.vue?vue&type=script&lang=js&"
export * from "./NewsLetterCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports